module.exports = __webpack_public_path__ + "img/GAME_COLORPAPER.f350c344.jpg";